"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-lock-closed.tsx
var LockClosed = function LockClosed(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M4.00008 35.6667C3.08341 35.6667 2.29869 35.3404 1.64591 34.6876C0.993137 34.0348 0.666748 33.2501 0.666748 32.3334V15.6667C0.666748 14.7501 0.993137 13.9654 1.64591 13.3126C2.29869 12.6598 3.08341 12.3334 4.00008 12.3334H5.66675V9.00008C5.66675 6.69453 6.47925 4.72925 8.10425 3.10425C9.72925 1.47925 11.6945 0.666748 14.0001 0.666748C16.3056 0.666748 18.2709 1.47925 19.8959 3.10425C21.5209 4.72925 22.3334 6.69453 22.3334 9.00008V12.3334H24.0001C24.9167 12.3334 25.7015 12.6598 26.3542 13.3126C27.007 13.9654 27.3334 14.7501 27.3334 15.6667V32.3334C27.3334 33.2501 27.007 34.0348 26.3542 34.6876C25.7015 35.3404 24.9167 35.6667 24.0001 35.6667H4.00008ZM4.00008 32.3334H24.0001V15.6667H4.00008V32.3334ZM14.0001 27.3334C14.9167 27.3334 15.7015 27.007 16.3542 26.3542C17.007 25.7015 17.3334 24.9167 17.3334 24.0001C17.3334 23.0834 17.007 22.2987 16.3542 21.6459C15.7015 20.9931 14.9167 20.6667 14.0001 20.6667C13.0834 20.6667 12.2987 20.9931 11.6459 21.6459C10.9931 22.2987 10.6667 23.0834 10.6667 24.0001C10.6667 24.9167 10.9931 25.7015 11.6459 26.3542C12.2987 27.007 13.0834 27.3334 14.0001 27.3334ZM9.00008 12.3334H19.0001V9.00008C19.0001 7.61119 18.514 6.43064 17.5417 5.45842C16.5695 4.48619 15.389 4.00008 14.0001 4.00008C12.6112 4.00008 11.4306 4.48619 10.4584 5.45842C9.48619 6.43064 9.00008 7.61119 9.00008 9.00008V12.3334Z",
    fill: "currentColor"
  }));
};

var _default = LockClosed;
exports.default = _default;